import { defineComponent as _defineComponent } from 'vue'


  
export default /*@__PURE__*/_defineComponent({
  __name: 'InputFile',
  props: {
    viewClass: {
      type: String,
      default: "button-primary-with-icon folder",
    },
    text: {
      type: String,
      default: "Upload",
    },
    accept: {
      type: String,
    },
    owner: {
      type: String,
    },
  },
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;
  const onChange = (event: Event) => {
    if (props.owner) {
      emits("change", event, props.owner);
    } else {
      emits("change", event);
    }
  };

const __returned__ = { emits, props, onChange }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})